import { get, isEqual } from 'lodash-es';
import { canUseDOM } from 'exenv';
import { scrollToElement as getScroll } from '@is24at/react-utils';

export const isEqualOnPaths = (a: any, b: any, paths = []) =>
  paths.every(
    (path) =>
      !!get(a, path) && !!get(b, path) && isEqual(get(a, path), get(b, path)),
  );

export const scrollToTop = (duration = 1) =>
  getScroll()('html', {
    offset: 0,
    ease: 'linear',
    duration,
  });

export const universalReplaceHistory = (
  replace,
  redirectIntent,
  nextLocationAsUrl,
) =>
  canUseDOM
    ? replace(nextLocationAsUrl)
    : redirectIntent.setRedirectLocation(nextLocationAsUrl);
